const e = "styles-module__menuItemWrapper___UE4Cc", t = "styles-module__scrolling___3wNV2", n = "styles-module__noHover___MnBHA", _ = "styles-module__labelContainer___1IyZN", o = "styles-module__labelTitle___COCKH", l = "styles-module__chevronIcon___3CAyY", s = "styles-module__noRotate___cNiDN", r = "styles-module__childContainer___I131v", c = "styles-module__menuItemContainer___-SLrf", a = "styles-module__active___yUBv5", i = "styles-module__shrunk___t-xwp", u = "styles-module__gradientButton___JzQWF", m = {
  menuItemWrapper: e,
  scrolling: t,
  noHover: n,
  labelContainer: _,
  labelTitle: o,
  chevronIcon: l,
  noRotate: s,
  childContainer: r,
  menuItemContainer: c,
  active: a,
  shrunk: i,
  gradientButton: u
};
export {
  a as active,
  l as chevronIcon,
  r as childContainer,
  m as default,
  u as gradientButton,
  _ as labelContainer,
  o as labelTitle,
  c as menuItemContainer,
  e as menuItemWrapper,
  n as noHover,
  s as noRotate,
  t as scrolling,
  i as shrunk
};
